import { CreateIncidenteDTO } from "@/application/dto/incidentes/CreateIncidenteDTO";
import { IIncidenteRepository } from "@/domain/repositories/IIncidenteRepository";

// application/use-cases/CreateIncidenteUseCase.ts

export class CreateIncidenteUseCase {

    constructor(
        private repository: IIncidenteRepository
    ) {}

    async execute(data: CreateIncidenteDTO) {
        
        return this.repository.create(data);
    }

}